module.exports = __webpack_public_path__ + "img/DE01057.9e494f34.png";